import axios from 'axios';
import { API_CALL_ERROR, BRANCHES_ENDPOINT,BRANCH_INFO_ENDPOINT,UPDATE_BRANCH_INFO_ENDPOINT } from './_ConstantsAPI';

export async function getBranch(branchId) {
  try {
    const { data } = await axios.get(BRANCHES_ENDPOINT, {
      params: {
        branchId: branchId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}


export async function getBranchInfo(branchId) {
  try {
    const { data } = await axios.get(BRANCH_INFO_ENDPOINT + '/' + branchId , {
      
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}


export async function updateBranchInfo(payload) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  try {
    const { data } = await axios.post(UPDATE_BRANCH_INFO_ENDPOINT, payload, {
      headers,
    });

    
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}